import { env } from '@config/env';
import { getAuthToken } from '@contexts/authContext';
import axios from 'axios';
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from '@services/auth';


export const api = axios.create({
  baseURL: env.apiURL
});

export const protectedApi = axios.create({
  baseURL: env.apiURL
});

protectedApi.interceptors.request.use((request) => {
  const token = getAuthToken();
  if (!token) {
    throw new Error('Token not found in the storage');
  }
  request.headers['Authorization'] = `Bearer ${token}`;
  return request;
});

protectedApi.interceptors.response.use(
  (response) => response,
  (error) => {
    // console.error('interceptor.error', error);
    if (error && axios.isAxiosError(error)) {
      const status = error.response?.status;
      const data = error.response?.data;
      // 401 => token rejected: expired/invalid, OR the user's account/clinic was
      // deactivated mid-session. Either way, drop the session and send to login.
      const sessionInvalid =
        status === 401 ||
        (data?.code === 401 && data?.detail === 'Token is expired or invalid');
      if (sessionInvalid) {
        window.localStorage.removeItem(ACCESS_TOKEN_KEY);
        window.localStorage.removeItem(REFRESH_TOKEN_KEY);
        window.location.reload();
      }
      console.error('interceptor.error', error);
    }
    return Promise.reject(error);
  }
);
